import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatOption, ThemePalette } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { formatRut, validateRut } from 'rutlib';
import { MatDialog } from '@angular/material/dialog';
import { TermConditionsComponent } from './components/modal/term-conditions/term-conditions.component';
import { AuthService } from '../service/auth.service';
import { environment } from 'src/environments/enviroments';
import { ReCaptchaV3Service } from 'ng-recaptcha';
export interface Task {
  name: string;
  completed: boolean;
  color: ThemePalette;
  subtasks?: Task[];
}

@Component({
  selector: 'app-boxed-register',
  templateUrl: './boxed-register.component.html',
  styleUrls: ['./boxed-register.scss'],
})
export class AppBoxedRegisterComponent implements OnInit {
  @ViewChild('select') select: MatSelect;
  @ViewChild('deleteSwal')
  public showRegister: number = 0;
  public readonly deleteSwal!: SwalComponent;
  public data: boolean = false;
  public allSelected: boolean = false;
  public validateRut: boolean = false;
  public validateRutCompany: boolean = false;
  public showInput: boolean = false;
  public validateRutSii: boolean = false;
  public getRutCompany: number = 0;
  public hide: boolean = true;
  public userRut: number = 0;
  public id: any;
  public token: any;
  public formulario: any;
  public reCAPTCHAToken: string = '';
  public tokenVisible: boolean = false;

  contactType: any[] = [
    { value: 'email', viewValue: 'Email' },
    { value: 'whatsapp', viewValue: 'Whatsapp' },
    { value: 'telefono', viewValue: 'Telefono' },
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private auth: AuthService,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {}
  
  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');  
    this.token = environment.recaptcha.siteKey;
  }

  form = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    email: new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
    ]),
    phone: new FormControl('', [
      Validators.required,
      Validators.pattern(/^(\+?56)?(\s?)(0?9)(\s?)[98765432]\d{7}$/),
    ]),
    contactType: new FormControl('', [Validators.required]),
    checkbox: new FormControl('', [Validators.requiredTrue]),
    userRut: new FormControl('', [Validators.required]),
    companyRut: new FormControl('', [Validators.required]),
    companySiiPassword: new FormControl('', [Validators.required]),
    referedBy: new FormControl(''),
  });

  get f() {
    return this.form.controls;
  }

  toggleAllSelection() {
    if (this.allSelected) {
      this.select.options.forEach((item: MatOption) => item.select());
    } else {
      this.select.options.forEach((item: MatOption) => item.deselect());
    }
  }

  optionClick() {
    let newStatus = true;
    this.select.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.allSelected = newStatus;
  }

  inputRut(): void {
    let rut: string = this.form.controls['userRut'].value!;
    const rutNumber = parseInt(rut);
    const formattedRut: string = formatRut(rut);
    this.form.controls['userRut'].setValue(formattedRut);
    const cleanedRutWithoutDots = rut.replace(/\./g, '');

    this.userRut = parseInt(
      cleanedRutWithoutDots.substring(0, cleanedRutWithoutDots.length - 1)
    );

    if (this.userRut >= 40000000) {
      this.form.controls['userRut'].setErrors({ incorrect: true });
    }
    this.validateRut = validateRut(rut);
  }

  inputRutCompany(): void {
    const companyRut: string = this.form.controls['companyRut'].value!;
    const cleanedCompanyRut = companyRut
      .replace(/[^\d-]/g, '')
      .replace(/[^\d.]/g, '');
    const formattedCompanyRut: string = formatRut(companyRut);

    this.form.controls['companyRut'].setValue(formattedCompanyRut);
    this.validateRutCompany = validateRut(companyRut);
    const cleanedRutWithoutDots = companyRut.replace(/\./g, '');
    this.getRutCompany = parseInt(
      cleanedRutWithoutDots.substring(0, cleanedRutWithoutDots.length - 1)
    );
    console.log(this.getRutCompany)
  }

  inputEmail() {
    let rut: string = this.form.controls['email'].value!;
    rut = rut.trim();

    this.form.controls['email'].setValue(rut);
  }

  openHeaderDialog() {
    const dialogRef = this.dialog.open(TermConditionsComponent, {
      data: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.form.controls['checkbox'].setValue(result);
    });
  }

  submit(form: any) {
    this.formulario = form;
    let timerInterval: any;
    form.contactType = form.contactType.toString();
    form.referedBy = this.id;
    this.recaptchaV3Service
      .execute('importantAction')
      .subscribe((token: string) => {
        this.tokenVisible = true;
        this.reCAPTCHAToken = `Token [${token}] generated`;
      });

    Swal.fire({
      text: 'Estamos validando tus credenciales',
      icon: 'question',
      timerProgressBar: true,

      didOpen: () => {
        Swal.showLoading();
        this.auth.registerNewUser(form).subscribe({
          next: (res) => {
            if (res.message == '') {
              timerInterval = setInterval(() => {
                this.validateSii(timerInterval);
              }, 5000);
              setTimeout(() => {
                if (this.validateRutSii === true) {
                  clearInterval(timerInterval);
                  Swal.fire({
                    text: '¡Registro Incompleto! Tu cuenta ha sido creada, pero la contraseña ingresada no se ha podido validar',
                    icon: 'info',
                    timerProgressBar: true,
                  });
                  this.router.navigate(['/success-register'], {
                    state: {
                      transd: (this.showRegister = 1),
                      form:form
                    },
                  });
                }
              }, 25000);
              this.validateRutSii = true;
            } else {
              Swal.fire({
                text: res.message,
                icon: 'info',
                timerProgressBar: true,
              });
            }
          },
          error: (err) => {
            Swal.fire({
              title: 'Error',
              text: err.error,
              icon: 'error',
              timerProgressBar: true,
            });
            console.log('Error', err);
          },
        });
      },
    });
  }

  validateSii(timerInterval: any) {
    let result;
    this.auth.validationStatus(this.getRutCompany).subscribe({
      next: (res) => {
        switch (res.content) {
          case 'Failed':
            Swal.update({
              icon: 'error',
              text: ' El rut o la clave tributaria es incorrecta',
            });
            Swal.hideLoading();
            this.validateRutSii = false;
            clearInterval(timerInterval);
            setTimeout(() => {
              Swal.close();
            }, 7000);
            break;
          case 'Succeed':
            Swal.close();
            clearInterval(timerInterval);
            this.router.navigate(['/success-register'], {
              skipLocationChange: true,
              replaceUrl: false,
              queryParams: { id: this.userRut },
              state: {
                transd: (this.showRegister = 0),
                form: this.formulario
              },
            });
            this.validateRutSii = false;
            break;
          default:
            break;
        }
        res.content;
      },
    });
    return result;
  }
}
